export default __webpack_public_path__ + "static/taichi_repo-8f3f5560826d12b1719c13cdcf4e0c09.png";